import { render, staticRenderFns } from "./MandatList.vue?vue&type=template&id=767d8396&"
import script from "./MandatList.vue?vue&type=script&lang=js&"
export * from "./MandatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports